
    <mat-select [formControl]="formControl" [formlyAttributes]="field">
    <mat-option> --- </mat-option>
      <div *ngFor="let item of items" >
        <mat-option *ngFor="let subItem of item.values" [value]="subItem._id">
          {{ subItem.nome }}
        </mat-option>
      </div>
    </mat-select>
  